// Module
var code = `<mat-dialog-content>
    <div class="hoa-dialog__container">
        <div class="hoa-dialog__header">
            <h1 tid="movedHeader">Have you moved?</h1>
        </div>
        <div class="hoa-dialog__main">
            <p tid="movedBody">
                If you have moved, please select Add Property to register your new property. <br><br>
                If you wish to delete this property, you can click "Delete Property" at the bottom of this page at any time.
            </p>
        </div>
        <div class="hoa-dialog__footer" if-overflow-x-class="hoa-dialog__footer--overflowX">
            <button class="Button Button--link Button--minWidth130" tid="movedNo" (click)="closeThisDialog(0)">No</button>
            <button class="Button Button--blue Button--minWidth130" tid="movedYes" (click)="closeThisDialog('Moved')">Add Property</button>
        </div>
    </div>
</mat-dialog-content>`;
// Exports
module.exports = code;